import React from 'react'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { SearchRankingsInfo } from '@dustin-web/product-components/src/search-rankings-info'
import RelatedCategories from './related-categories'
import Suggestions from './suggestions'
import Products from './products'
import type {
  RelatedCategoriesQuery,
  SuggestionsQuery,
  RecentSearchesQuery,
  ProductsQuery,
  RecentlyViewedQuery,
  TopSellingProductsQueryProducts,
} from '@dustin-web/microsite-baselayout/src/components/header/types'
import SearchUserLinks from './user'

type Pops = {
  searchPhrase: string
  relatedCategories: RelatedCategoriesQuery
  suggestions: SuggestionsQuery
  recentSearches?: RecentSearchesQuery
  products: ProductsQuery | TopSellingProductsQueryProducts
  recentlyViewed?: RecentlyViewedQuery
  clearRecentSearchesHandler: () => void
  clearRecentSearchHandler?: (title?: string | null) => void
  clearRecentViewedHandler: () => void
}

const InstantSearchMiniLayout = ({
  searchPhrase,
  relatedCategories,
  suggestions,
  recentSearches = [],
  products,
  recentlyViewed = [],
  clearRecentSearchesHandler,
  clearRecentSearchHandler,
  clearRecentViewedHandler,
}: Pops) => {
  const { translate } = useTranslations()
  const isProductsVisible = !!products?.length && !!searchPhrase
  const isRecentlyViewedVisible = !!recentlyViewed?.length && !searchPhrase
  const isSuggestionsVisible = !!suggestions?.length
  const isRecentSearchesVisible = !!recentSearches?.length && !searchPhrase
  const isRelatedCategoriesVisible = !!relatedCategories?.length && !!searchPhrase

  const relatedCategoriesHeader = () => (
    <p className="c-header__autocomplete-mini-header">
      <span>
        {searchPhrase}
        <span style={{ fontStyle: 'italic' }}>{` ${translate('Within')}`}</span>
      </span>
    </p>
  )
  const recentSearchesHeader = () => {
    return (
      <p className="c-header__autocomplete-mini-header">
        <span className="c-header__autocomplete-mini-label">{translate('Recent_Searches')}</span>
        <button
          type="button"
          className="c-header__autocomplete-mini-btn u-decoration-underline u-color-black"
          aria-label="clear all"
          onClick={clearRecentSearchesHandler}>
          {translate('Clear_All')}
        </button>
      </p>
    )
  }
  const suggestionsHeader = () => (
    <p className="c-header__autocomplete-mini-header">
      {(searchPhrase && translate('Suggested_Searches')) || translate('Popular_Searches')}
    </p>
  )
  const productsHeader = () => (
    <p className="c-header__autocomplete-mini-header">{translate('Suggested_Products')}</p>
  )
  const recentlyViewedHeader = () => (
    <p className="c-header__autocomplete-mini-header">
      {translate('Recently_Viewed')}
      <button
        type="button"
        className="c-header__autocomplete-mini-btn u-decoration-underline u-color-black"
        aria-label="clear all"
        onClick={() => {
          clearRecentViewedHandler()
        }}>
        {translate('Clear_All')}
      </button>
    </p>
  )

  return (
    <>
      {isRelatedCategoriesVisible && (
        <RelatedCategories
          searchPhrase={searchPhrase}
          relatedCategories={relatedCategories}
          header={relatedCategoriesHeader()}
        />
      )}
      {isRecentSearchesVisible && (
        <Suggestions
          recentSearches={recentSearches}
          searchPhrase={searchPhrase}
          icon={'disaster-recovery'}
          header={recentSearchesHeader()}
          clearRecentSearchHandler={clearRecentSearchHandler}
        />
      )}
      {isSuggestionsVisible && (
        <Suggestions
          suggestions={suggestions}
          searchPhrase={searchPhrase}
          header={suggestionsHeader()}
          icon={'search'}
        />
      )}
      {isProductsVisible && <Products products={products} header={productsHeader()} />}
      {isRecentlyViewedVisible && (
        <Products products={recentlyViewed} header={recentlyViewedHeader()} />
      )}
      <SearchUserLinks searchPhrase={searchPhrase} />
      <div className="c-header__autocomplete-mini-footer">
        <SearchRankingsInfo withIcon={false} buttonVariant="text" popoverPositions={['top-right', 'right']} />
      </div>
    </>
  )
}

export default InstantSearchMiniLayout
